import script from "./InformationInterface.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationInterface.vue?vue&type=script&setup=true&lang=ts"

import "./InformationInterface.vue?vue&type=style&index=0&id=9787b8ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9787b8ba"]])

export default __exports__